import axios from 'axios'

axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

// 念のため、ヘッダーが欠落している場合に Cookie から補完する
axios.interceptors.request.use((config) => {
  // 既にヘッダーがあるなら何もしない
  if (config.headers && !('X-XSRF-TOKEN' in config.headers)) {
    // ブラウザの document.cookie から XSRF-TOKEN を取り出す（簡易パーサ）
    const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
    if (match && typeof match[1] === 'string') {
      try {
        // Cookie値は URLエンコードされているので decode
        const token = decodeURIComponent(match[1])
        config.headers['X-XSRF-TOKEN'] = token
      } catch {
        config.headers['X-XSRF-TOKEN'] = match[1] ?? ''
      }
    }
  }
  return config
})
